import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "@/features/header/logo";
import LogoutAdmin from "./logout-admin";
import AddWalletsBtn from "./add-wallets-btn";
import AddWalletsModal from "../add-wallets-modal/add-wallets";
import NavigationItems from "@pages/wallet-discovery/admin-header/navigation-items.tsx";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import clsx from "clsx";

const AdminHeader = () => {
  const { isConnected } = useWeb3Auth();
  const [showModal, setShowModal] = useState(false);

  return (
    <header
      className={clsx(
        "h-[2.5rem] flex items-center justify-between w-full",
        !isConnected && "pointer-events-none blur-sm",
      )}
    >
      <Link
        className="h-[2.5rem] flex items-center justify-start pr-[5.1875rem]"
        to="/"
      >
        <Logo />
      </Link>

      <div className="h-full flex justify-center items-center">
        <div className="flex gap-[0.3125rem] rounded-3xl p-[0.3125rem]">
          <NavigationItems />
        </div>
      </div>

      <div className="flex justify-end items-center gap-[0.625rem]">
        <LogoutAdmin />
        <AddWalletsBtn onClick={() => setShowModal(true)} />
      </div>

      <AddWalletsModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </header>
  );
};

export default AdminHeader;
